import { Credentials } from './credentials';
import { defaultSortActivityMode, SortActivityMode } from './sort-activity-mode';
import { UserInfo } from './user-info';

export interface PersonalUserPreferences {
    lastActivityNumbers: number[];
    sortActivityMode: SortActivityMode;
}

export interface UserSession {
    credentials: Credentials;
    data: PersonalUserPreferences;
    startedOn: number;
    userInfo: UserInfo | undefined;
}

export const defaultPersonalUserPreferences: PersonalUserPreferences = {
    lastActivityNumbers: [],
    sortActivityMode: defaultSortActivityMode,
};
